import type { SelectOption } from '@shinetools/lumen-react'

import { type Account, AccountNature } from '@modules-deprecated/app/accounts/types'
import { getAccountLabel } from '@views/suppliers/utils/getAccountLabel'

export const getPurchaseCategoryOptions = (accounts: Account[], selectedAccountId?: string): SelectOption[] => {
  const options = accounts
    .filter((account) => !account.isArchived && account.natureId === AccountNature.Expense)
    .map((account) => ({
      label: getAccountLabel(account),
      value: account.id,
    }))

  if (selectedAccountId && !options.some((option) => option.value === selectedAccountId)) {
    const selectedAccount = accounts.find((account) => account.id === selectedAccountId)

    if (selectedAccount) {
      return [{ label: getAccountLabel(selectedAccount), value: selectedAccount.id }, ...options]
    }
  }

  return options
}
